export const USER_ROLES = {
  DIRECTOR_USER: "Director",
  SUPER_USER: "Super",
  MD_USER: "MD",
  EXECUTIVE_USER: "Executive",
  ADMIN_USER: "Admin",
  MANAGER_USER: "Manager",
  SUPERVISOR_USER: "Supervisor",
  EMPLOYEE_USER: "Employee",
  GUEST_USER: "Guest",
};

export const userRolesAccessRights = (role: string) => { };

// STRATEGIC THEME ID'S

// OMUTHTIYA
// export const THEMES = {
//   OPERATIONAL: "NWahhDXK6d8NbO76kf0c",
//   SUPPLY: "KpiClUFkz0RXCw8dyTdS",
//   HARNESS: "qZ3vUwLDCfRqVHtZi6xF",
//   DIGITAL: "7kBoZD7Q9LflIz0OteTK",
// };

// ORANDJEMUND
// export const THEMES = {
//   OPERATIONAL: "FrAIZipcULGA7yDVTBq1",
//   SUPPLY: "GlCmGVuItIWg9cKOwqvA",
//   HARNESS: "dMQSAvzAoPYFMVLHjXvM",
//   DIGITAL: "hpWAESXBGxhEsavG52KG",
// };


// OKAHANDJA
// export const THEMES = {
//   OPERATIONAL: "0Hc8DuHI4SQMtSFoF14p",
//   SUPPLY: "D970zDJ3Gt4YB4YGQDrZ",
//   HARNESS: "LIbjqXAsL5mcis7kxxqq",
//   DIGITAL: "P394vpeD3M2mAXOwAxMk",
// };


// OMUTHIYA
// export const THEMES = {
//   OPERATIONAL: "NWahhDXK6d8NbO76kf0c",
//   SUPPLY: "KpiClUFkz0RXCw8dyTdS",
//   HARNESS: "qZ3vUwLDCfRqVHtZi6xF",
//   DIGITAL: "7kBoZD7Q9LflIz0OteTK",
// };


// NKURENKURU
// export const THEMES = {
//   OPERATIONAL: "NWahhDXK6d8NbO76kf0c",
//   SUPPLY: "KpiClUFkz0RXCw8dyTdS",
//   HARNESS: "qZ3vUwLDCfRqVHtZi6xF",
//   DIGITAL: "7kBoZD7Q9LflIz0OteTK",
// };